<mg-notification-base
  [read]="notification?.read"
  [viewed]="notification?.viewed"
  [icon]="notification?.iconUrl"
  [iconColor]="notification?.iconColor"
  [avatarSrc]="notification?.image | mgAssetUrl:'preview'"
  [timestamp]="notification?.timestamp">
  <mg-notification-base-title *ngIf="notification?.title as title">
    {{title | mgStripHtml}}
  </mg-notification-base-title>

  <mg-notification-base-body> {{notification?.body | mgStripHtml}} </mg-notification-base-body>
</mg-notification-base>
